<template>
  <aha-modal @hide="handleHideModal()" title="Are you sure?">
    <div :inner-html.prop="modalContent" />
    <template #action>
      <aha-button
        variant="danger"
        :disabled="isDeletingStatement"
        @click="handleUpdateStatement()"
        :submitting="isDeletingStatement"
        has-margin-right
      >
        Delete
      </aha-button>
      <aha-link @click="handleHideModal">
        <span class="font-bold">Cancel</span>
      </aha-link>
    </template>
  </aha-modal>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import utils from '@/util'
import SlideApi from '@/api/slide'
import gaCategories from '@/constant/gaCategories'
import EventBus from '@/eventBus'
import Sentry from '@/services/sentry'

export default {
  props: {
    modalContent: {
      type: String,
      default: '',
    },
    deleteSlideOptionIndex: {
      type: Number,
      default: null,
    },
  },
  data: () => {
    return {
      isDeletingStatement: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    handleHideModal() {
      this.$emit('hide')
    },
    handleUpdateStatement() {
      this.isDeletingStatement = true
      this.$emit('deleteOption', this.slideActive.SlideOptions[this.deleteSlideOptionIndex],
        this.deleteSlideOptionIndex, () => { this.handleUpdateSlide() })
    },
    async handleUpdateSlide() {
      const payload = {
        presentationId: this.presentation.id,
        slideId: [this.slideActive.id],
      }
      try {
        await SlideApi.clearSlides(payload)
        this.updateSlideActiveAction({
          hasScaleQuestionAnswer: false,
          multipleCountAnswer: 0,
        })
        this.$store.state.tempAudienceCount = 0
        EventBus.$emit('reloadScaleChart')
        this.isDeletingStatement = false
        this.handleHideModal()
        utils.gaTrackEvent(
          gaCategories.PRESENTATION_EDITOR,
          'Right column > Content Tab > Confirm remove statement > Removed',
        )
      } catch (error) {
        Sentry.captureException(`Error delete scale statement when has votes: ${error}`)
      }
    },
  },
}
</script>
